export default __webpack_public_path__ + "static/media/pop-out.48dfcb58.svg";